import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { IgniteBaseComponent } from "../ignite-base/ignite-base.component";
import { IgniteOtpConfig } from "../../models/ignite-otp-config";
import { NgOtpInputConfig } from "ng-otp-input";
import { FormControl } from "@angular/forms";
import { take, takeUntil, tap } from "rxjs";

@Component({
  selector: "ignite-otp",
  templateUrl: "./ignite-otp.component.html",
  styleUrl: "./ignite-otp.component.scss",
  standalone: false,
})
export class IgniteOtpComponent extends IgniteBaseComponent implements OnInit {
  public static DEFAULT_OTP_LENGTH = 6;

  otpControl: FormControl = new FormControl("");

  @Input() config: IgniteOtpConfig = {
    length: IgniteOtpComponent.DEFAULT_OTP_LENGTH,
    allowNumbersOnly: true,
    showResend: true,
  };
  @Output() otpEntered = new EventEmitter<string>();
  @Output() resendClicked = new EventEmitter<void>();

  otpConfig: NgOtpInputConfig = new NgOtpInputConfig();

  ngOnInit(): void {
    this.otpConfig = {
      length: this.config.length,
      allowNumbersOnly: this.config.allowNumbersOnly,
      inputClass: "otp-control",
      isPasswordInput: this.config.isPasswordInput ?? false,
      disableAutoFocus: this.config.disableAutoFocus ?? false,
      placeholder: this.config.placeholder ?? "",
      letterCase: this.config.letterCase ?? "Upper",
      separator: this.config.separator,
    };

    this.otpControl.valueChanges
      .pipe(
        takeUntil(this.unsubscribe$),
        tap((otp: string) => {
          if (otp?.length === this.config.length) {
            this.otpEntered.emit(otp);
          }
        })
      )
      .subscribe();
  }

  handleResendClick(): void {
    this.otpControl.setValue("");
    this.resendClicked.emit();
  }
}
